import { Component, Input } from '@angular/core';
import { FormControl, FormGroup, UntypedFormControl } from '@angular/forms';
import { NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-validation-message',
    templateUrl: './validation-message.component.html',
    styleUrls: ['./validation-message.component.scss'],
    imports: [NgIf, TranslateModule]
})
export class ValidationMessageComponent {
    @Input({ required: true }) public control: FormControl | FormGroup | UntypedFormControl;

    @Input({ required: true }) public languageKey: string;
}
